import { PrivateInterceptor } from '../../Base/interceptors/PrivateInterceptor'


export const getDespachosLost = async (data) => {
    const result = await PrivateInterceptor('Planning/DespachosEspeciales', 'POST', data)
    return result;
}
export const PermisosDespachosEspeciales = async (data) => {
    const result = await PrivateInterceptor('Planning/DespachosEspeciales/PermisosDespachosEspeciales', 'POST',data)
    return result;
}